import {
    takeLatest, all, put, call,
} from 'redux-saga/effects';
import API from '../common/API';
import { waitAuthorizedCheck } from './Auth';
import * as Actions from '../actions/SettingProductCompany';

function* getSettingProductCompany(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const endpoint = `/api/v1/company/${action.payload.company_id}/product_sales_settings/`;
        const response = yield call(
            API.get, {
                endpoint: `${endpoint}`,
                token: credential.data.token,
                body: {},
            },
        );
        yield put(Actions.GetSettingProductCompanyRequestedReceived(response));
    } catch (error) {
        yield put(Actions.GetSettingProductCompanyRequestedReceivedFailure(yield error));
    }
}

function* updateSettingProductCompany(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const endpoint = `/api/v1/company/${action.payload.company_id}/product_sales_settings/`;
        const response = yield call(
            API.put, {
                endpoint: `${endpoint}`,
                body: action.payload.data,
                token: credential.data.token,
            },
        );
        yield put(Actions.UpdateSettingProductCompanyRequestedReceived(response));
    } catch (error) {
        yield put(Actions.UpdateSettingProductCompanyRequestedReceivedFailure(yield error));
    }
}

export default function* login() {
    yield all([
        takeLatest('GET_SETTING_PRODUCT_COMPANY_REQUESTED', getSettingProductCompany),
        takeLatest('UPDATE_SETTING_PRODUCT_COMPANY_REQUESTED', updateSettingProductCompany),
    ]);
}
